import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import Client from './ClientModel';
import FundingEnquiryPurpose from './FundingEnquiryPurposeModel';
import FundingEnquiryUrgency from './FundingEnquiryUrgencyModel';

const FundingEnquiryAnswersRecord = Record({
  client: null,
  purpose: null,
  urgency: null,
});

export default class FundingEnquiryAnswers extends FundingEnquiryAnswersRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      client: Client.deserialize,
      purpose: FundingEnquiryPurpose.deserialize,
      urgency: FundingEnquiryUrgency.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new FundingEnquiryAnswers(hydrated);
  }
}
